import { useParams } from 'react-router-dom';
import { createRoute, useEntityUrl } from 'framework/routing';
export * from './staffingProject';

const PROJECTS_SEGMENT = 'projects';
const PROJECT_PATH = `/${PROJECTS_SEGMENT}`;
const WEEKLY_REPORTS_SEGMENT = 'reports';
const WEEKLY_REPORT_ID = 'reportId';

export const getProjectListUrl = () => PROJECT_PATH;

export const getProjectRouterPath = () => `${PROJECT_PATH}/*`;

export const useProjectRoute = () => {
  const routers = createRoute({ listRoute: PROJECT_PATH, timelinePostfix: 'statuses' });
  const getSingleProjectStatusUrl = (projectId: string, statusId: string) =>
    `${PROJECTS_SEGMENT}/${projectId}/statuses/${statusId}`;

  return {
    ...routers,
    weeklyReportRoute: `${routers.singleEntityRoute}/${WEEKLY_REPORTS_SEGMENT}/*`,
    dashboardRoute: `${routers.singleEntityRoute}/dashboard`,
    redmineProjectRoute: `${routers.singleEntityRoute}/redmine-project`,
    wbsDashboardProjectRoute: `${routers.singleEntityRoute}/wbs-dashboard`,
    sowRoute: `${routers.singleEntityRoute}/sow/*`,
    getSingleProjectStatusUrl,
  };
};

export const useProjectId = () => {
  const { id } = useParams<Dictionary<string>>();

  return id!;
};

export const useProjectUrl = () => {
  return useEntityUrl({
    baseLink: PROJECT_PATH,
  });
};

export const useProjectWeeklyReportRoute = () =>
  createRoute({
    listRoute: `/${WEEKLY_REPORTS_SEGMENT}`,
    singleEntityRoute: `/:${WEEKLY_REPORT_ID}`,
  });

export const useProjectWeeklyReportId = () => useParams<Dictionary<string>>()[WEEKLY_REPORT_ID];

export const useProjectWeeklyReportsUrl = () => {
  const { getSingleEntityUrl } = useProjectUrl();
  const listUrl = `${getSingleEntityUrl()}/${WEEKLY_REPORTS_SEGMENT}`;
  const baseUrls = useEntityUrl({
    baseLink: listUrl,
    idSource: WEEKLY_REPORT_ID,
  });

  const getListUrl = () => listUrl;
  const getSingleEntityLink = (reportId: string, projectId: string) => {
    return `${getSingleEntityUrl(projectId)}/${WEEKLY_REPORTS_SEGMENT}/${reportId}`;
  };

  return {
    ...baseUrls,
    getListUrl,
    getSingleEntityLink,
  };
};
